"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsMobileDevice = void 0;
const react_1 = require("react");
const utils_1 = require("@hivebrite/utils");
const window_resize_1 = require("../window-resize");
const useIsMobileDevice = () => {
    const [isMobileDevice, setIsMobileDevice] = (0, react_1.useState)(utils_1.mobileDeviceFromUserAgent.any());
    (0, window_resize_1.useWindowResize)(() => setIsMobileDevice(Boolean(utils_1.mobileDeviceFromUserAgent.any())));
    return isMobileDevice;
};
exports.useIsMobileDevice = useIsMobileDevice;
//# sourceMappingURL=index.js.map